import script from "./AuthenticationDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AuthenticationDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AuthenticationDialog.vue?vue&type=style&index=0&id=1fd42efa&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1fd42efa"]])

export default __exports__